/** Origen del flujo auth compartido (activar / recordar / desbloquear). */
export const AUTH_FLOW_ORIGEN_KEY = 'auth-flow-origen';

export type AuthFlowOrigen = 'micro' | 'if';

export function setAuthFlowOrigen(origen: AuthFlowOrigen): void {
  try {
    sessionStorage.setItem(AUTH_FLOW_ORIGEN_KEY, origen);
  } catch {
    // ignore
  }
}

/** Default micro si no hay origen (URL directa). */
export function getAuthFlowOrigen(): AuthFlowOrigen {
  try {
    const raw = sessionStorage.getItem(AUTH_FLOW_ORIGEN_KEY);
    return raw === 'if' ? 'if' : 'micro';
  } catch {
    return 'micro';
  }
}

export function getAuthFlowBgDesktop(origen: AuthFlowOrigen = getAuthFlowOrigen()): string {
  return origen === 'if'
    ? 'assets/img/login/login-if.png'
    : 'assets/img/login/login-microempresario.png';
}

export function getAuthFlowBgMobile(origen: AuthFlowOrigen = getAuthFlowOrigen()): string {
  return origen === 'if'
    ? 'assets/img/login/login-if-mobile.png'
    : 'assets/img/login/login-microempresario-mobile.png';
}
